 
import { nextTick } from 'vue'; 
//service
import BzbsHistory from '@/core/History/service/BzbsHistory.js';

export default {   
    methods: { 
        //#endregion use
        showConfirmMarkUsed: function (purchase) { 
            let campaignName = purchase.name;
            this.modalController.confirmModal
                .clearModal()
                .setTitle(this.lbl.customHistory.confirm.title)
                .setMsg(campaignName)
                .setBtnCancel(this.lbl.confirm_redeem.cancel)
                .setBtnOk(this.lbl.confirm_redeem.confirm)
                .onClickOk(() => {
                    this.callUseCampaign(purchase);
                })
                .onClickCancel(() => { 
                })
                .show()
        },

        callUseCampaign: function (purchase) { 
            BzbsHistory.apiRedeemUse(purchase.redeemKey).subscribe((result) => { 
                purchase.updateAfterRedeem(result); 
                // reload page
                nextTick(() => { 
                    window.location.reload();
                });
            }, (err) => { 
                console.log(err);
            });
        },
        //#endregion use
    },
}
